<template>
    <div class="ax-road-page" :class="{ 'ax-road-page--padded': !noPadding }">
        <div v-if="isLoading" class="l-stack l-center l-padded">
            <VSpinner size="medium" :line-fg-color="spinnerColor" :speed="1" />
        </div>

        <div v-else class="ax-road-page__head">
            <h1 class="l-grow-1">{{ title }}</h1>

            <slot name="header" />

            <IconButton v-if="closable" @click="handleClose">
                <RemoveIcon />
            </IconButton>
        </div>

        <div class="ax-road-page__body">
            <slot />
        </div>
    </div>
</template>

<script>
import VSpinner from 'vue-simple-spinner'

import IconButton from '@/components/IconButton'
import RemoveIcon from '@/components/icons/RemoveIcon'

export default {
    name: 'AxRoadPage',
    components: {
        IconButton,
        RemoveIcon,
        VSpinner,
    },
    props: {
        closable: {
            type: Boolean,
            default: true,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        noPadding: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            spinnerColor: process.env.VUE_APP_COLOR_PRIMARY,
        }
    },
    methods: {
        handleClose() {
            const parentPath = this.$route.path
                .split('/')
                .slice(0, -1)
                .join('/')
            if (parentPath) {
                this.$router.push({
                    path: parentPath,
                    query: this.$route.query,
                })
            } else {
                this.$router.push('/')
            }
        },
    },
}
</script>

<style lang="scss">
.ax-road-page {
    $self: &;
    overflow-y: auto;

    &__head {
        position: sticky;
        top: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 12px;
        padding: 24px 24px 12px;
        border-bottom: $style-border;
        background-color: #fff;
        z-index: 1005;

        h1 {
            font-size: 20px;
            line-height: 28px;
            font-weight: 500;
        }
    }

    &__body {
        padding: 0 0 24px;
    }

    &--padded {
        #{$self}__head {
            margin: 0 24px;
            padding-right: 0;
            padding-left: 0;
        }

        #{$self}__body {
            margin: 24px;
            padding: 0;
        }
    }

    @include respond-to('for-mobile-down') {
        margin-left: 58px;
        width: calc(100% - 58px) !important;
    }
}
</style>
